/* eslint-disable no-shadow */
import { createAction, props } from '@ngrx/store';

export enum ActionTypes {
  SalesforceLoginAndGetObjects = '[SalesforceState] SalesforceLoginAndGetObjects',
  SalesforceLoginAndGetObjectsSuccessful = '[SalesforceState] SalesforceLoginAndGetObjectsSuccessful',
  SalesforceLoginAndGetObjectsFailure = '[SalesforceState] SalesforceLoginAndGetObjectsFailure',
  SalesforceLoginAndGetSelectedObjects = '[SalesforceState] SalesforceLoginAndGetSelectedObjects',
  SalesforceLoginAndGetSelectedObjectsSuccessful = '[SalesforceState] SalesforceLoginAndGetSelectedObjectsSuccessful',
  SalesforceLoginAndGetSelectedObjectsFailure = '[SalesforceState] SalesforceLoginAndGetSelectedObjectsFailure',
  SalesforceSelectedObjectsUpdate = '[SalesforceState] SalesforceSelectedObjectsUpdate',
  CreateSalesforceObject = '[SalesforceState] CreateSalesforceObject',
  CreateSalesforceObjectSuccessful = '[SalesforceState] CreateSalesforceObjectSuccessful',
  CreateSalesforceObjectFailure = '[SalesforceState] CreateSalesforceObjectFailure',
  GetSalesforceObjectName = '[SalesforceState] GetSalesforceObjectName',
  ResetSalesforce = '[SalesforceState] ResetSalesforce'
}

export const SalesforceLoginAndGetObjects = createAction(
  ActionTypes.SalesforceLoginAndGetObjects
);

export const SalesforceLoginAndGetObjectsSuccessful = createAction(
  ActionTypes.SalesforceLoginAndGetObjectsSuccessful,
  props<{ payload: { objects: any } }>()
);

export const SalesforceLoginAndGetObjectsFailure = createAction(
  ActionTypes.SalesforceLoginAndGetObjectsFailure,
  props<{ payload: { error: any; key: string; timestamp: number } }>()
);

export const SalesforceLoginAndGetSelectedObjects = createAction(
  ActionTypes.SalesforceLoginAndGetSelectedObjects,
  props<{ payload: { username: string; password: string; token: string } }>()
);

export const SalesforceLoginAndGetSelectedObjectsSuccessful = createAction(
  ActionTypes.SalesforceLoginAndGetSelectedObjectsSuccessful,
  props<{ payload: { selectedObjects: any; username: string; password: string; token: string } }>()
);

export const SalesforceLoginAndGetSelectedObjectsFailure = createAction(
  ActionTypes.SalesforceLoginAndGetSelectedObjectsFailure,
  props<{ payload: { error: any; key: string; timestamp: number } }>()
);

export const SalesforceSelectedObjectsUpdate = createAction(
  ActionTypes.SalesforceSelectedObjectsUpdate,
  props<{ payload: { selectedObjects: string[] } }>()
);

export const CreateSalesforceObject = createAction(
  ActionTypes.CreateSalesforceObject,
  props<{ payload: { frequency: string; objects: string[], currentObjectNames: any } }>()
);

export const CreateSalesforceObjectSuccessful = createAction(
  ActionTypes.CreateSalesforceObjectSuccessful
);

export const CreateSalesforceObjectFailure = createAction(
  ActionTypes.CreateSalesforceObjectFailure,
  props<{ payload: { error: any; key: string; timestamp: number } }>()
);

export const GetSalesforceObjectName = createAction(
  ActionTypes.GetSalesforceObjectName,
  props<{ payload: { frequency: string; objects: string[] } }>()
);

export const ResetSalesforce = createAction(
  ActionTypes.ResetSalesforce
);
